import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m18.325 18.068.295.867c.217.64-.073 1.34-.679 1.64a13.45 13.45 0 0 1-11.882 0c-.606-.3-.896-1-.679-1.64l.295-.867A6 6 0 0 1 11.355 14h1.29a6 6 0 0 1 5.68 4.068M16 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }
  )
);
var SvgUserFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var UserFilled_default = SvgUserFilled;

export { UserFilled_default as default };
